import { createFileRoute, redirect } from '@tanstack/react-router'

import { RETURN_SHAPE } from '@/lib/return-to'
import { readSearch } from '@/lib/search-params'

/**
 * L'ancienne adresse du plan de recette (lot 25) : depuis #365, le plan vit
 * sous les recettes du projet. Un lien gardé y mène encore.
 */
export const Route = createFileRoute('/_app/projects/$projectRef_/livrables_/$key_/recette')({
  validateSearch: (search: Record<string, unknown>) => readSearch(RETURN_SHAPE, search),
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/projects/$projectRef/recettes/$key',
      params: { projectRef: params.projectRef, key: params.key },
      search,
      replace: true,
    })
  },
})
